jQuery(document).ready(function() {
  var slider = jQuery('.home-slides').bxSlider({
    mode: 'fade',
    controls: true,
    auto: true,
    pause: 10000,
    responsive: true,
    pager: false,
    touchEnabled: false,
    onSlideNext: doThis,
    onSlidePrev: doThis
  });
  var slider_caption = jQuery('.home-slides-mobile').bxSlider({
    mode: 'fade',
    controls: false,
    auto: true,
    pause: 10000,
    responsive: true,
    pager: false,
    touchEnabled: false,
    onSlideNext: doThis,
    onSlidePrev: doThis
  });

  function doThis(ele, old, newi) {
    slider.goToSlide(newi);
    slider_caption.goToSlide(newi);
  }
});
